import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "grid grid-cols-3 gap-6"
};
const _hoisted_2 = {
  class: "col-span-1"
};
const _hoisted_3 = {
  class: "bg-white rounded-xl border border-slate-200 p-6 text-center"
};
const _hoisted_4 = {
  class: "relative inline-block mb-4"
};
const _hoisted_5 = {
  class: "w-24 h-24 rounded-full bg-indigo-100 flex items-center justify-center overflow-hidden"
};
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = {
  key: 1,
  class: "text-indigo-600 font-bold text-3xl"
};
const _hoisted_8 = ["disabled"];
const _hoisted_9 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_10 = {
  key: 1,
  class: "w-4 h-4 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
};
const _hoisted_11 = {
  class: "text-lg font-semibold text-slate-800"
};
const _hoisted_12 = {
  class: "text-sm text-slate-500 mt-1"
};
const _hoisted_13 = {
  class: "mt-6 pt-6 border-t border-slate-100"
};
const _hoisted_14 = {
  class: "flex items-center justify-center gap-2 text-sm text-slate-600"
};
const _hoisted_15 = {
  class: "bg-white rounded-xl border border-slate-200 p-6 mt-6"
};
const _hoisted_16 = {
  class: "space-y-3"
};
const _hoisted_17 = {
  class: "col-span-2 space-y-6"
};
const _hoisted_18 = {
  class: "bg-white rounded-xl border border-slate-200 p-6"
};
const _hoisted_19 = {
  class: "grid grid-cols-2 gap-x-6 gap-y-4"
};
const _hoisted_20 = {
  class: "flex items-center h-10"
};
const _hoisted_21 = {
  class: "text-sm text-slate-800"
};
const _hoisted_22 = {
  class: "flex items-center h-10"
};
const _hoisted_23 = {
  class: "text-sm text-slate-800"
};
const _hoisted_24 = {
  class: "flex items-center h-10"
};
const _hoisted_25 = {
  class: "text-sm text-slate-800"
};
const _hoisted_26 = {
  class: "flex items-center h-10"
};
const _hoisted_27 = {
  class: "text-sm text-slate-800"
};
const _hoisted_28 = {
  class: "flex items-center h-10"
};
const _hoisted_29 = {
  class: "text-sm text-slate-800"
};
const _hoisted_30 = {
  class: "flex items-center h-10"
};
const _hoisted_31 = {
  class: "text-sm text-slate-800"
};
const _hoisted_32 = {
  class: "bg-white rounded-xl border border-slate-200 p-6"
};
const _hoisted_33 = {
  class: "space-y-3"
};
const _hoisted_34 = {
  key: 0,
  class: "flex items-center justify-center py-8 text-sm text-slate-500"
};
const _hoisted_35 = {
  class: "flex items-center gap-3"
};
const _hoisted_36 = {
  key: 0,
  class: "w-4 h-4 text-green-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_37 = {
  key: 1,
  class: "w-4 h-4 text-red-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_38 = {
  class: "text-sm font-medium text-slate-800"
};
const _hoisted_39 = {
  class: "text-xs text-slate-500"
};
const _hoisted_40 = {
  class: "text-right"
};
const _hoisted_41 = {
  class: "text-xs text-slate-400"
};
const _hoisted_42 = {
  key: 2,
  class: "text-center py-8 text-sm text-slate-500"
};
const _hoisted_43 = {
  class: "space-y-4"
};
const _hoisted_44 = {
  class: "relative"
};
const _hoisted_45 = ["type"];
const _hoisted_46 = {
  key: 0,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_47 = {
  key: 1,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_48 = {
  class: "relative"
};
const _hoisted_49 = ["type"];
const _hoisted_50 = {
  key: 0,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_51 = {
  key: 1,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_52 = {
  class: "relative"
};
const _hoisted_53 = ["type"];
const _hoisted_54 = {
  key: 0,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_55 = {
  key: 1,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_56 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
};
const _hoisted_57 = {
  key: 1,
  class: "mt-2 text-sm text-red-600"
};
const _hoisted_58 = {
  class: "flex justify-end gap-3 mt-6"
};
const _hoisted_59 = ["disabled"];
import { ref, computed, onMounted } from 'vue';
import { useUserStore } from '@/stores/user';
import { getLoginLogs, changePassword } from '@/api/auth';
import { uploadFile } from '@/api/file';
import { updateAvatar } from '@/api/user';
import { compressImage } from '@/utils/imageCompress';
import { ElMessage } from 'element-plus';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'Profile',
  setup(__props) {
    const userStore = useUserStore();
    const loginLogs = ref([]);
    const loadingLogs = ref(false);
    const avatarInputRef = ref(null);
    const uploadingAvatar = ref(false);

    // 修改密码弹窗相关
    const showPasswordModal = ref(false);
    const submittingPassword = ref(false);
    const passwordError = ref('');
    const passwordForm = ref({
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
    const showOldPassword = ref(false);
    const showNewPassword = ref(false);
    const showConfirmPassword = ref(false);

    // 输入时清除错误提示
    function clearPasswordError() {
      passwordError.value = '';
    }

    // 头像上传
    async function handleAvatarChange(event) {
      const file = event.target.files?.[0];
      if (!file) return;
      // 重置input以便可以重复选择同一文件
      event.target.value = '';
      if (file.size > 2 * 1024 * 1024) {
        ElMessage.warning('图片大小不能超过 2MB');
        return;
      }
      try {
        uploadingAvatar.value = true;
        // 1. 压缩图片
        const compressed = await compressImage(file, {
          maxWidth: 400,
          maxHeight: 400,
          quality: 0.8
        });

        // 2. 上传文件获取OSS key
        const res = await uploadFile(compressed, 'avatar', 'public');
        const avatarKey = res.fileName || res.data?.fileName;
        if (!avatarKey) {
          ElMessage.error('上传失败，未获取到图片地址');
          return;
        }
        // 2. 调用修改头像接口
        await updateAvatar(avatarKey);
        // 3. 刷新用户信息
        await userStore.fetchUserInfo();
        ElMessage.success('头像修改成功');
      } catch (error) {
        ElMessage.error(error?.message || '头像修改失败');
      } finally {
        uploadingAvatar.value = false;
      }
    }
    const confirmPasswordError = computed(() => {
      return passwordForm.value.confirmPassword !== '' && passwordForm.value.newPassword !== '' && passwordForm.value.confirmPassword !== passwordForm.value.newPassword;
    });
    const displayName = computed(() => {
      return userStore.userInfo?.displayName || userStore.userInfo?.username || '用户';
    });
    const avatarUrl = computed(() => {
      return userStore.userInfo?.avatar || '';
    });
    const nameInitial = computed(() => {
      const name = displayName.value;
      return name ? name.charAt(0).toUpperCase() : 'U';
    });
    const genderText = computed(() => {
      const gender = userStore.userInfo?.gender;
      if (gender === '0') return '男';
      if (gender === '1') return '女';
      if (gender === '2') return '未知';
      return '未知';
    });
    function formatTime(timeStr) {
      if (!timeStr) return '-';
      const date = new Date(timeStr);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
    function closePasswordModal() {
      showPasswordModal.value = false;
      passwordForm.value = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
      passwordError.value = '';
      showOldPassword.value = false;
      showNewPassword.value = false;
      showConfirmPassword.value = false;
    }
    async function handleChangePassword() {
      passwordError.value = '';

      // 验证
      if (!passwordForm.value.oldPassword) {
        passwordError.value = '请输入旧密码';
        return;
      }
      if (!passwordForm.value.newPassword) {
        passwordError.value = '请输入新密码';
        return;
      }
      const password = passwordForm.value.newPassword;
      if (password.length < 6 || password.length > 20) {
        passwordError.value = '密码长度必须在6-20位之间';
        return;
      }
      if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(password)) {
        passwordError.value = '密码必须包含大小写字母和数字';
        return;
      }
      if (password !== passwordForm.value.confirmPassword) {
        passwordError.value = '两次输入的密码不一致';
        return;
      }
      try {
        submittingPassword.value = true;
        await changePassword({
          oldPassword: passwordForm.value.oldPassword,
          newPassword: passwordForm.value.newPassword
        });
        closePasswordModal();
        // 修改成功后登出
        await userStore.doLogout();
      } catch (error) {
        passwordError.value = error.message || '修改失败，请检查旧密码是否正确';
      } finally {
        submittingPassword.value = false;
      }
    }
    async function fetchLoginLogs() {
      try {
        loadingLogs.value = true;
        const logs = await getLoginLogs();
        loginLogs.value = logs || [];
      } catch (error) {
        console.error('获取登录记录失败:', error);
        loginLogs.value = [];
      } finally {
        loadingLogs.value = false;
      }
    }
    onMounted(() => {
      fetchLoginLogs();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_cache[33] || (_cache[33] = _createElementVNode("div", {
        class: "mb-6"
      }, [_createElementVNode("h1", {
        class: "text-xl font-semibold text-slate-800"
      }, "个人中心"), _createElementVNode("p", {
        class: "text-sm text-slate-500 mt-1"
      }, "管理您的个人信息和账户设置")], -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [avatarUrl.value ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: avatarUrl.value,
        alt: displayName.value,
        class: "w-full h-full object-cover"
      }, null, 8, _hoisted_6)) : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(nameInitial.value), 1))]), _createElementVNode("input", {
        ref_key: "avatarInputRef",
        ref: avatarInputRef,
        type: "file",
        accept: "image/*",
        class: "hidden",
        onChange: handleAvatarChange
      }, null, 544), _createElementVNode("button", {
        class: "absolute bottom-0 right-0 w-8 h-8 bg-white border border-slate-200 rounded-full flex items-center justify-center text-slate-500 hover:text-slate-700 hover:bg-slate-50 shadow-sm cursor-pointer transition-colors",
        disabled: uploadingAvatar.value,
        onClick: _cache[0] || (_cache[0] = $event => avatarInputRef.value?.click())
      }, [!uploadingAvatar.value ? (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[8] || (_cache[8] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
      }, null, -1), _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M15 13a3 3 0 11-6 0 3 3 0 016 0z"
      }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[9] || (_cache[9] = [_createElementVNode("circle", {
        class: "opacity-25",
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "4"
      }, null, -1), _createElementVNode("path", {
        class: "opacity-75",
        fill: "currentColor",
        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      }, null, -1)]))]))], 8, _hoisted_8)]), _createElementVNode("h2", _hoisted_11, _toDisplayString(displayName.value), 1), _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(userStore).userInfo?.phone || '-'), 1), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_cache[10] || (_cache[10] = _createElementVNode("svg", {
        class: "w-4 h-4 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
      })], -1)), _createElementVNode("span", null, _toDisplayString(_unref(userStore).userInfo?.deptName || '暂无部门'), 1)])])]), _createElementVNode("div", _hoisted_15, [_cache[12] || (_cache[12] = _createElementVNode("h3", {
        class: "text-sm font-semibold text-slate-800 mb-4"
      }, "账户安全", -1)), _createElementVNode("div", _hoisted_16, [_createElementVNode("button", {
        class: "flex items-center justify-between w-full p-3 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer group",
        onClick: _cache[1] || (_cache[1] = $event => showPasswordModal.value = true)
      }, [...(_cache[11] || (_cache[11] = [_createStaticVNode("<div class=\"flex items-center gap-3\"><div class=\"w-10 h-10 bg-green-50 rounded-lg flex items-center justify-center\"><svg class=\"w-5 h-5 text-green-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z\"></path></svg></div><div class=\"text-left\"><p class=\"text-sm font-medium text-slate-800\">登录密码</p><p class=\"text-xs text-slate-500\">定期修改密码，保障账户安全</p></div></div><svg class=\"w-5 h-5 text-slate-400 group-hover:text-slate-600 transition-colors\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 5l7 7-7 7\"></path></svg>", 2)]))])])])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_cache[19] || (_cache[19] = _createElementVNode("h3", {
        class: "text-sm font-semibold text-slate-800 mb-6"
      }, "基本信息", -1)), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_cache[13] || (_cache[13] = _createElementVNode("span", {
        class: "w-20 text-sm text-slate-500 flex-shrink-0"
      }, "用户名", -1)), _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(userStore).userInfo?.username || '-'), 1)]), _createElementVNode("div", _hoisted_22, [_cache[14] || (_cache[14] = _createElementVNode("span", {
        class: "w-20 text-sm text-slate-500 flex-shrink-0"
      }, "显示名称", -1)), _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(userStore).userInfo?.displayName || '-'), 1)]), _createElementVNode("div", _hoisted_24, [_cache[15] || (_cache[15] = _createElementVNode("span", {
        class: "w-20 text-sm text-slate-500 flex-shrink-0"
      }, "手机号码", -1)), _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(userStore).userInfo?.phone || '-'), 1)]), _createElementVNode("div", _hoisted_26, [_cache[16] || (_cache[16] = _createElementVNode("span", {
        class: "w-20 text-sm text-slate-500 flex-shrink-0"
      }, "邮箱", -1)), _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(userStore).userInfo?.email || '-'), 1)]), _createElementVNode("div", _hoisted_28, [_cache[17] || (_cache[17] = _createElementVNode("span", {
        class: "w-20 text-sm text-slate-500 flex-shrink-0"
      }, "性别", -1)), _createElementVNode("span", _hoisted_29, _toDisplayString(genderText.value), 1)]), _createElementVNode("div", _hoisted_30, [_cache[18] || (_cache[18] = _createElementVNode("span", {
        class: "w-20 text-sm text-slate-500 flex-shrink-0"
      }, "所属部门", -1)), _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(userStore).userInfo?.deptName || '-'), 1)])])]), _createElementVNode("div", _hoisted_32, [_cache[22] || (_cache[22] = _createElementVNode("h3", {
        class: "text-sm font-semibold text-slate-800 mb-4"
      }, "登录记录", -1)), _createElementVNode("div", _hoisted_33, [loadingLogs.value ? (_openBlock(), _createElementBlock("div", _hoisted_34, " 加载中... ")) : loginLogs.value.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(loginLogs.value, log => {
        return _openBlock(), _createElementBlock("div", {
          key: log.id,
          class: "flex items-center justify-between p-3 bg-slate-50 rounded-lg"
        }, [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", {
          class: _normalizeClass(["w-8 h-8 rounded-full flex items-center justify-center", log.status === 0 ? 'bg-green-100' : 'bg-red-100'])
        }, [log.status === 0 ? (_openBlock(), _createElementBlock("svg", _hoisted_36, [...(_cache[20] || (_cache[20] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M5 13l4 4L19 7"
        }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_37, [...(_cache[21] || (_cache[21] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        }, null, -1)]))]))], 2), _createElementVNode("div", null, [_createElementVNode("p", _hoisted_38, _toDisplayString(log.status === 0 ? '登录成功' : '登录失败'), 1), _createElementVNode("p", _hoisted_39, _toDisplayString(log.browser) + " · " + _toDisplayString(log.os) + " · " + _toDisplayString(log.clientIp), 1)])]), _createElementVNode("div", _hoisted_40, [_createElementVNode("p", {
          class: _normalizeClass(["text-xs", log.status === 0 ? 'text-green-600' : 'text-red-600'])
        }, _toDisplayString(log.status === 0 ? '成功' : '失败'), 3), _createElementVNode("p", _hoisted_41, _toDisplayString(formatTime(log.loginTime)), 1)])]);
      }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_42, " 暂无登录记录 "))])])])]), _createVNode(AppModal, {
        visible: showPasswordModal.value,
        size: "sm",
        "panel-class": "p-6",
        "close-on-overlay": false,
        onClose: closePasswordModal
      }, {
        default: _withCtx(() => [_cache[32] || (_cache[32] = _createElementVNode("h3", {
          class: "text-lg font-semibold text-slate-800 mb-6"
        }, "修改密码", -1)), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", null, [_cache[25] || (_cache[25] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "旧密码", -1)), _createElementVNode("div", _hoisted_44, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => passwordForm.value.oldPassword = $event),
          type: showOldPassword.value ? 'text' : 'password',
          class: "form-input pr-10",
          placeholder: "请输入旧密码",
          onInput: clearPasswordError
        }, null, 40, _hoisted_45), [[_vModelDynamic, passwordForm.value.oldPassword]]), _createElementVNode("button", {
          type: "button",
          class: "absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 cursor-pointer",
          onClick: _cache[3] || (_cache[3] = $event => showOldPassword.value = !showOldPassword.value)
        }, [showOldPassword.value ? (_openBlock(), _createElementBlock("svg", _hoisted_46, [...(_cache[23] || (_cache[23] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
        }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_47, [...(_cache[24] || (_cache[24] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
        }, null, -1), _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
        }, null, -1)]))]))])])]), _createElementVNode("div", null, [_cache[28] || (_cache[28] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "新密码", -1)), _createElementVNode("div", _hoisted_48, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => passwordForm.value.newPassword = $event),
          type: showNewPassword.value ? 'text' : 'password',
          class: "form-input pr-10",
          placeholder: "6-20位，必须包含大小写字母和数字",
          onInput: clearPasswordError
        }, null, 40, _hoisted_49), [[_vModelDynamic, passwordForm.value.newPassword]]), _createElementVNode("button", {
          type: "button",
          class: "absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 cursor-pointer",
          onClick: _cache[5] || (_cache[5] = $event => showNewPassword.value = !showNewPassword.value)
        }, [showNewPassword.value ? (_openBlock(), _createElementBlock("svg", _hoisted_50, [...(_cache[26] || (_cache[26] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
        }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_51, [...(_cache[27] || (_cache[27] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
        }, null, -1), _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
        }, null, -1)]))]))])])]), _createElementVNode("div", null, [_cache[31] || (_cache[31] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "确认新密码", -1)), _createElementVNode("div", _hoisted_52, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => passwordForm.value.confirmPassword = $event),
          type: showConfirmPassword.value ? 'text' : 'password',
          class: _normalizeClass(['w-full px-3 py-2 pr-10 rounded-lg focus:outline-none', confirmPasswordError.value ? 'border border-red-500 focus:ring-2 focus:ring-red-500' : 'border border-slate-300 focus:ring-2 focus:ring-primary-500']),
          placeholder: "请再次输入新密码",
          onInput: clearPasswordError
        }, null, 42, _hoisted_53), [[_vModelDynamic, passwordForm.value.confirmPassword]]), _createElementVNode("button", {
          type: "button",
          class: "absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 cursor-pointer",
          onClick: _cache[7] || (_cache[7] = $event => showConfirmPassword.value = !showConfirmPassword.value)
        }, [showConfirmPassword.value ? (_openBlock(), _createElementBlock("svg", _hoisted_54, [...(_cache[29] || (_cache[29] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
        }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_55, [...(_cache[30] || (_cache[30] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
        }, null, -1), _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
        }, null, -1)]))]))])])])]), passwordError.value ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(passwordError.value), 1)) : confirmPasswordError.value ? (_openBlock(), _createElementBlock("p", _hoisted_57, "两次输入的密码不一致")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_58, [_createElementVNode("button", {
          class: "btn-secondary",
          onClick: closePasswordModal
        }, " 取消 "), _createElementVNode("button", {
          class: "btn-primary",
          disabled: submittingPassword.value,
          onClick: handleChangePassword
        }, _toDisplayString(submittingPassword.value ? '提交中...' : '确认修改'), 9, _hoisted_59)])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};